import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getSiteData = (params) => {
    return AxiosService.Get(`api/cam/pc/site-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };



  getMetaList = () => {
    return AxiosService.Get(`api/cam/pc/dropdown-all/`, {
      ...this.getHeaders(),
      // params: params,
    });
  };

  addSite = (data, obj) => {
    return AxiosService.Post(`api/cam/pc/create-site/`, data, {
      // params: data,
      ...this.getHeaders(),
    });
  };

  deleteSite = (obj) => {
    return AxiosService.Delete(`api/cam/pc/delete-site/`, obj);
  };
  
  approveSite = (obj) => {
    return AxiosService.Post(`api/cam/pc/approve-site/`, obj);
  };

  updateSite = (obj) => {
    return AxiosService.Put(
      `api/cam/pc/update-site/`,
      obj,
      // params,
      true,
      this.getHeaders()
    );
  };
}
